// app/[lng]/providers.tsx
"use client";

import { ReactNode } from "react";
import { SnackbarProvider } from "notistack";

export default function Provider({ children }: { children: ReactNode }) {
  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      maxSnack={3}
    >
      {children}
    </SnackbarProvider>
  );
}
